/* eslint-disable jsx-a11y/heading-has-content */
import { useEffect, useState } from 'react';
import ProgressBar from '@ramonak/react-progress-bar';
import email from '../../assets/images/email.svg';
import arrowDown from '../../assets/images/arrow-down.svg';
import arrowUp from '../../assets/images/arrow-up.svg';
import { useNavigate } from 'react-router-dom';
import { StudentDashboardSidebar } from '../../components/StudentDashboardSidebar';
import StudentNavbar from '../../components/StudentNavbar';
import polygon_arrow from '../../assets/images/Polygon-arrow.svg';
import { forStudentClassDetails } from '../../Store/api/activities';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

const StudentSubject = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [gotoSubject] = useState(1);
  const [arrowImage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [redoActivity, setRedoActivity] = useState();
  const [tooltipVisible, setTooltipVisible] = useState(null);
  const [percentageGraded, setPercentageGraded] = useState([]);
  const [studentClassDetials, setStudentClassDetials] = useState([]);

  const currentDate = new Date();
  const sevenDaysLater = new Date(currentDate);
  sevenDaysLater.setDate(currentDate.getDate() + 14);
  /* ............................... */

  const WeekDays = ['S', 'M', 'Tu', 'W', 'Th', 'F', 'Sa'];

  useEffect(() => {
    if (studentClassDetials && studentClassDetials.chapters) {
      let totalGradedMarks = 0;
      let totalPossibleMarks = 0;
      let totalActivities = 0;
      let completedAndGradedActivities = 0;
      let hasGradedActivities = false; // New flag to track graded activities

      // Loop through chapters and activities to calculate the totals
      studentClassDetials.chapters.forEach((chapter) => {
        if (chapter.activities) {
          chapter.activities.forEach((activity) => {
            totalActivities++; // Count all activities

            if (activity.activityAnswers && activity.activityAnswers.length > 0) {
              let activityGradedMarks = 0;
              let activityPossibleMarks = 0;

              activity.activityAnswers.forEach((answer) => {
                if (answer.isGraded) {
                  hasGradedActivities = true; // At least one activity is graded
                  activityGradedMarks += answer.grade; // Sum of all graded marks
                  activityPossibleMarks += answer.totalMarks; // Total possible marks for this answer
                }
              });

              // Add to total if the activity has graded answers
              if (activityGradedMarks > 0) {
                totalGradedMarks += activityGradedMarks;
                totalPossibleMarks += activityPossibleMarks;
                completedAndGradedActivities++;
              }
            }
          });
        }
      });

      // Assuming each activity is worth 100 marks
      const totalPossibleMarksForPercentage = totalActivities * 100;

      const percentage = totalPossibleMarksForPercentage > 0 && (totalGradedMarks / totalPossibleMarksForPercentage) * 100;

      const roundedPercentage = Math.round(percentage);
      setPercentageGraded(hasGradedActivities ? roundedPercentage : null); // Set null if no graded activities
    }
  }, [studentClassDetials]);

  // Mapping activites 'chapters'
  const submittedActivities = studentClassDetials?.chapters?.map((chapter) => chapter.activities.filter((activity) => activity?.activityAnswers?.some((answer) => !answer.isGraded && answer.answers && answer.answers.length > 0 && answer.activityStatus !== 'InProgress'))).flat();

  const pastActivities = studentClassDetials?.chapters
    ?.map((chapter) =>
      chapter.activities.filter((activity) => {
        const assignedDate = new Date(activity.assignedDate).setHours(0, 0, 0, 0); // Normalize date
        const currentDate = new Date().setHours(0, 0, 0, 0); // Today's date

        // Check if assigned date is past
        if (assignedDate >= currentDate || !activity.activityAnswers?.length) return false;
        return activity.activityAnswers.some(
          (answer) =>
            !answer.isGraded && // Not graded
            (!answer.answers.length || // No answers
              (answer.answers.length && answer.activityStatus === 'InProgress'))
        );
      })
    )
    .flat();

  const nextActivities = studentClassDetials?.chapters?.map((chapter) => chapter?.activities?.filter((activity) => new Date(activity.assignedDate).setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0) && new Date(activity.assignedDate).setHours(0, 0, 0, 0) < new Date(sevenDaysLater).setHours(0, 0, 0, 0) && activity.activityAnswers && activity.activityAnswers.length > 0 && activity.activityAnswers.some((ans) => (!ans.isGraded && !ans.answers.length) || (ans.activityStatus === 'InProgress' && ans.answers.length > 0)))).flat();

  useEffect(() => {
    if (studentClassDetials && studentClassDetials.chapters) {
      const currentDate = new Date();
      const sevenDaysLater = new Date();
      sevenDaysLater.setDate(currentDate.getDate() + 7);

      // Flatten all activities
      const allActivities = studentClassDetials.chapters?.map((chapter) => chapter?.activities || []).flat();

      // Filter activities based on assigned date and ensure valid answers
      const upcomingActivities = allActivities.filter((activity) => {
        const assignedDate = new Date(activity.assignedDate).setHours(0, 0, 0, 0);
        return (
          assignedDate >= currentDate.setHours(0, 0, 0, 0) && assignedDate < sevenDaysLater.setHours(0, 0, 0, 0) && activity.activityAnswers && activity.activityAnswers.length > 0 && activity.activityAnswers.some((ans) => ans.answers && ans.answers.length > 0) // Ensure valid answers exist
        );
      });

      // Filter activities to include only those not at 100% completion
      const incompleteActivities = upcomingActivities.filter((activity) => {
        const totalMarks = activity.activityAnswers.length * 100; // Total marks assuming each answer is worth 100
        const gradedMarks = activity.activityAnswers.reduce((sum, answer) => {
          return answer.isGraded ? sum + answer.grade : sum;
        }, 0);

        // Calculate the percentage
        const percentage = totalMarks > 0 ? (gradedMarks / totalMarks) * 100 : 0;
        return percentage < 100;
      });

      setRedoActivity(incompleteActivities.length);
    }
  }, [studentClassDetials]);

  /* ..........................///////////////////////////// */

  const handleMouseEnter = (courseIndex, day) => {
    setTooltipVisible((prevTooltipDays) => ({
      ...prevTooltipDays,
      [courseIndex]: day,
    }));
  };
  const handleMouseLeave = (courseIndex) => {
    setTooltipVisible((prevTooltipDays) => ({
      ...prevTooltipDays,
      [courseIndex]: null,
    }));
  };

  useEffect(() => {
    setLoading(true);
    dispatch(
      forStudentClassDetails({
        id: id,
        onSuccess: (res) => {
          setStudentClassDetials(res?.data?.data);

          setLoading(false);
        },
        onError: (err) => {
          setLoading(false);
        },
      })
    );
  }, [id]);

  /* For daynamic object  */
  const progressBar = {
    // completed: calculatedPercentages,
    bgColor: '#6700B2',
    borderRadius: '6px',
    baseBgColor: '#DDD5EB',
    labelColor: '#6700B2',
    labelSize: '15px',
    height: '15px',
    width: '100%',
    labelAlignment: 'right',
  };

  const instructors = studentClassDetials?.additionalInstructors?.map((item) => `${item.firstName} ${item.lastName}`) || [];

  return (
    <>
      <div className='wrapper'>
        <StudentDashboardSidebar sideBarEvent={'class'} setGotoSubject={1} gotoSubject={gotoSubject} />
        <div id='content'>
          <div className='content_dashborad_inner p-0'>
            <StudentNavbar sideBarEvent={'classes'} />
            <div>
              <div className='main_section_content'>
                <div className='center_content full_width class_details_page p-0' style={{ height: '93vh', overflow: 'inherit' }}>
                  <div className='class_details_page_header margn_top cursor_default' style={{ height: '153.8px', paddingLeft: '42px' }}>
                    <div className='user_info_class' style={{ width: '38%' }}>
                      <h5 className='ft_24 d-flex align-items-center class_header-student mb-16'>
                        <img className='cursor' alt='arrow-left' src='/assets/images/arrow-left.png' onClick={() => navigate('/studentdashboard/classes')} />
                        {loading ? <div className='content-skeleton mb-0 mb-2' style={{ height: '24px' }}></div> : <>{studentClassDetials.courseName}</>}
                      </h5>
                      <h3 className='ft_20 txt_up mb-16 class_header-student'>{loading ? <div className='content-skeleton ' style={{ height: '24px' }}></div> : <>{studentClassDetials.courseNumber}</>}</h3>
                      <h6 className='fts__14 mb-8 class_header-instructor d-flex align-items-center w-100' style={{ height: '35px' }}>
                        <div className='d-flex align-items-center justify-content-start'>Primary Instructor </div>
                        {loading ? (
                          <div className='content-skeleton mb-0' style={{ marginLeft: '3.2%' }}></div>
                        ) : (
                          <div className='fw-400 class_header-student d-flex align-items-center gap-2' style={{ marginLeft: '3.2%' }}>
                            {studentClassDetials.createdBy?.image && <img alt='user' width={35} height={35} src={studentClassDetials.createdBy?.image} style={{ borderRadius: '50%' }} />}
                            <span className='instrc_name'>{`${studentClassDetials?.createdBy?.firstName} ${studentClassDetials?.createdBy?.lastName}`}</span>

                            {/* Mailto link for email */}
                            {studentClassDetials?.createdBy?.email && (
                              <a href={`https://mail.google.com/mail/?view=cm&fs=1&to=${studentClassDetials.createdBy.email}`} target='_blank' rel='noopener noreferrer'>
                                <img
                                  src={email}
                                  alt='email'
                                  style={{
                                    paddingLeft: '5px',
                                  }}
                                  className='class_email cursor'
                                />
                              </a>
                            )}
                          </div>
                        )}
                      </h6>
                      <h6 className='fts__14 class_header-instructor d-flex'>
                        <div style={{ width: '25.5%' }}>Instructors </div>
                        {loading ? <div className='content-skeleton m-0'></div> : <span className='instruc_name txt_cap fw-400'>{instructors.join(', ')}</span>}
                      </h6>
                    </div>

                    <div className='right_content_box w-50 me-0'>
                      <div className='box_border date_Schedule mt_32 me-0 w-60'>
                        <div className='intero w-100 class_header-student'>
                          <h1 className='ft_14 fw-600 txt_cap'>Schedule</h1>
                          {loading ? (
                            <div className='content-skeleton mb-0 ' style={{ height: '24px' }}></div>
                          ) : (
                            <div className='Create-custom-schedule mb-0 w-75'>
                              <ul className='gap-2'>
                                {WeekDays.map((day, dayIndex) => (
                                  <li key={dayIndex} className='option_1'>
                                    <input type='checkbox' id={day} className='custom-checkbox' disabled />
                                    <label
                                      htmlFor={day}
                                      style={{
                                        backgroundColor: studentClassDetials?.schedule?.replace(/\s/g, '').split(',').includes(day) ? 'black' : '',
                                        color: studentClassDetials?.schedule?.replace(/\s/g, '').split(',').includes(day) ? 'white' : '',
                                      }}
                                      onMouseEnter={() => handleMouseEnter(dayIndex, day)}
                                      onMouseLeave={() => handleMouseLeave(dayIndex)}
                                    >
                                      <span className='title_1'>{day}</span>
                                      {studentClassDetials?.schedule?.replace(/\s/g, '').split(',').includes(day) && tooltipVisible?.[dayIndex] === day && (
                                        <div
                                          className='calendar_tooltip_box arrow-center'
                                          style={{
                                            top: '-52px',
                                            height: '40px',
                                          }}
                                        >
                                          <div className='tooltip_text'>
                                            <div className='fw-400' style={{ display: 'inline' }}>
                                              {' '}
                                              10:30am - 12:30pm
                                            </div>
                                          </div>
                                          <div
                                            className='arrow-frame'
                                            style={{
                                              position: 'absolute',
                                              bottom: '-9px',
                                            }}
                                          >
                                            <img className='arrow_down' src={polygon_arrow} alt='polygon arrow' />
                                          </div>
                                        </div>
                                      )}
                                    </label>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                        </div>

                        <div className='class_intro class_header-student'>
                          <div className='mb-8 class_header-student'>
                            <div className='intero d-flex due_in_next'>
                              <h1 className='ft_14 fw-600 txt_cap activity_width'>Activities</h1>
                              {loading ? (
                                <h4 className='content-skeleton m-12' style={{ marginLeft: '5px' }}></h4>
                              ) : (
                                <h6 className='fts__14 fw-400 txt_smal'>
                                  <b>{nextActivities?.length}</b> due in next 14 days
                                </h6>
                              )}
                            </div>
                          </div>
                          <div className='intero   d-flex  due_in_next mb-10  class_header-instructor'>
                            <h1 className='ft_14 fw-600 text-white activity_width'>Activities</h1>
                            {loading ? (
                              <h4 className='content-skeleton ml-2'></h4>
                            ) : (
                              <h6 className='fts__14 fw-400 txt_smal'>
                                {' '}
                                <b>{submittedActivities?.length}</b> submitted for teacher grading
                              </h6>
                            )}
                          </div>
                          <div className='intero   d-flex  due_in_next mb-10 class_header-instructor'>
                            <h1 className='ft_14 fw-600 text-white activity_width'>Activities</h1>
                            {loading ? (
                              <h4 className='content-skeleton ml-2'></h4>
                            ) : (
                              <h6 className='fts__14 fw-400 txt_smal'>
                                {' '}
                                <b>{pastActivities?.length}</b> past due
                              </h6>
                            )}
                          </div>
                          <div className='intero   d-flex  due_in_next mb-10 class_header-instructor'>
                            <h1 className='ft_14 fw-600 text-white activity_width'>Activities</h1>
                            {loading ? (
                              <h4 className='content-skeleton ml-2'></h4>
                            ) : (
                              <h6 className='fts__14 fw-400 txt_smal'>
                                {' '}
                                <b>{redoActivity}</b> redo available
                              </h6>
                            )}
                          </div>
                        </div>
                        {/* Add more content here */}
                      </div>
                      <div className='total_box_price'>
                        <h1 className='ft_40 accumulative-grade'>{loading ? <div className='content-skeleton mb-0'></div> : <>{percentageGraded !== null ? (percentageGraded > 0 ? Math.round(percentageGraded) : '0') : '--'}%</>}</h1>
                        <p className='ft_Cumulative  mt_32'>cumulative Grade</p>
                      </div>
                    </div>
                  </div>

                  <div className='faqs_wrap ps-2 me-4'>
                    <div className='faqs_header cursor_default'>
                      <h5 className='ft_16 fw-600 m-0'>chapters</h5>
                      <h5 className='ft_16 fw-600 m-0'>number of activities</h5>
                      <h5 className='ft_16 fw-600 m-0'>progress of completion</h5>
                      <h5 className='ft_16 fw-600 r_138 m-0'>chapter grade</h5>
                    </div>
                    <div
                      className='accordion accordion-flush cursor_default'
                      style={{
                        overflowY: 'scroll',
                        maxHeight: '71vh',
                        borderRadius: '6px',
                      }}
                      id='accordionFlushExample'
                    >
                      {studentClassDetials?.chapters
                        ?.sort((a, b) => a.order - b.order)
                        .map((chapter, index) => (
                          <div key={index} className='accordion-item'>
                            <h2 className='accordion-header' id={`flush-heading${index}`}>
                              <button className='accordion-button collapsed' type='button' data-bs-toggle='collapse' data-bs-target={`#flush-collapse${index}`} aria-expanded='false' aria-controls={`flush-collapse${index}`}>
                                <div className='button_inner'>
                                  <h4 className='ft_16 ft_17'>Chapters {chapter?.order}</h4>
                                  <h4 className='ft_16 ft_17'>{chapter?.activities?.length} activities</h4>

                                  {/* Calculate the percentage based on grades */}
                                  {(() => {
                                    let totalGradedAnswers = 0;
                                    let totalQuestions = 0;

                                    // Iterate over each activity in the chapter
                                    chapter?.activities?.forEach((activity) => {
                                      // Count the number of graded answers
                                      const gradedAnswers = activity.activityAnswers.filter((answer) => answer.isGraded === true).length;

                                      // Update the total graded answers
                                      totalGradedAnswers += gradedAnswers;

                                      // Get the total number of questions for the activity

                                      totalQuestions = chapter?.activities.length;
                                    });

                                    // Calculate the percentage based on graded answers and total questions
                                    const percentageBasedOnGrades = totalQuestions > 0 ? (totalGradedAnswers / totalQuestions) * 100 : 0;

                                    return (
                                      <div style={{ width: '300px' }}>
                                        <ProgressBar completed={percentageBasedOnGrades} bgColor={progressBar.bgColor} borderRadius={progressBar.borderRadius} baseBgColor={progressBar.baseBgColor} labelColor={progressBar.labelColor} labelSize={progressBar.labelSize} height={progressBar.height} width={progressBar.width} labelAlignment={progressBar.labelAlignment} />
                                      </div>
                                    );
                                  })()}

                                  {(() => {
                                    let totalGrades = 0;
                                    let maxPossibleGrades = 0;
                                    let hasGradedActivities = false; // New flag to track if any activity is graded

                                    chapter?.activities?.forEach((activity) => {
                                      activity.activityAnswers.forEach((answer) => {
                                        // if (answer.isGraded) {
                                        hasGradedActivities = true; // At least one activity is graded
                                        totalGrades += answer.grade || 0;
                                        maxPossibleGrades += 100; // Adjust if your maximum grade is different
                                        // }
                                      });
                                    });

                                    // Calculate the percentage based on grades
                                    const percentageBasedOnGrades = maxPossibleGrades > 0 ? (totalGrades / maxPossibleGrades) * 100 : 0;

                                    return (
                                      <h4 className='ft_16 r_138 ft_17' style={{ width: '50px' }}>
                                        {
                                          hasGradedActivities
                                            ? Math.round(percentageBasedOnGrades) // Show percentage if graded activities exist
                                            : '--' // Show "--" if no graded activities
                                        }
                                        %
                                      </h4>
                                    );
                                  })()}
                                </div>

                                <div style={{ marginRight: '15px' }}>
                                  <img src={arrowImage ? arrowUp : arrowDown} alt='arrow' />
                                </div>
                              </button>
                            </h2>
                            <div id={`flush-collapse${index}`} className='accordion-collapse collapse' aria-labelledby={`flush-heading${index}`}>
                              <div className='accordion-body' style={{ background: '#fff' }}>
                                {chapter?.activities?.map((activity, innerIndex) => {
                                  // Initialize total grades and max possible grades
                                  let totalGrades = 0;
                                  let maxPossibleGrades = 0;

                                  // Filter graded activities
                                  const gradedActivity = activity.activityAnswers.filter((answer) => answer.isGraded);

                                  // Calculate total grades and maximum possible grades
                                  activity.activityAnswers.forEach((activityAnswer) => {
                                    if (activityAnswer.isGraded) {
                                      totalGrades += activityAnswer.grade || 0;
                                      maxPossibleGrades += 100; // Adjust this if your maximum grade is different
                                    }
                                  });

                                  // Calculate the percentage based on grades
                                  const percentageBasedOnGrades = maxPossibleGrades > 0 ? (totalGrades / maxPossibleGrades) * 100 : 0;

                                  // Calculate completed count and total answers
                                  const completed = gradedActivity.length > 0;

                                  let totalCorrectAnswers = 0;
                                  let totalAnswers = 0;

                                  activity.activityAnswers.forEach((activityAnswer) => {
                                    activityAnswer.answers.forEach((answer) => {
                                      if (answer.isGraded && answer.isCorrect) {
                                        totalCorrectAnswers++;
                                      }
                                      totalAnswers++;
                                    });
                                  });

                                  return (
                                    <div key={innerIndex} className='button_inner fw_400'>
                                      <h4 className='ft_16 txt_cap ft_17 fw_400'>{activity.title}</h4>
                                      <div
                                        style={{
                                          width: '45%',
                                          display: 'flex',
                                          justifyContent: 'space-between',
                                        }}
                                      >
                                        <h4 className='ft_16 ft_17 fw_400'>{completed ? 'Complete' : 'Incomplete'}</h4>

                                        <h4 className='ft_16 l_138 ft_17 fw_400'>
                                          {!completed ? (
                                            <>{activity.questions.length} questions</>
                                          ) : (
                                            <>
                                              {completed && totalCorrectAnswers}/{activity.questions.length} {completed && 'correct'}
                                            </>
                                          )}
                                        </h4>

                                        <h4 className='ft_16 ft_17 fw_400'>{gradedActivity.length > 0 ? `${percentageBasedOnGrades.toFixed(0)}%` : '--%'}</h4>
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default StudentSubject;
